import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table'

import { adminContractors } from '../../../core/controllers/Admin/AdminContractors'
import { adminUserAccounts } from '../../../core/controllers/Admin/AdminUserAccounts'
import { user } from '../../../core/controllers/user'
import { modal } from '../../../core/utilities/modal'

export default class ContractorTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contractorData: null
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        adminContractors.getContractors(function(response){
            self.setState({
                contractorData: response.data
            })
        })
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatActionOptions(cell, row) {
        return (
        <div>
            <button type="button" class="btn btn-info btn-secondary btn-fill" autoComplete="off" onClick={this.logAsUser.bind(this, row)}>
                Login
            </button>
            {row.status == '2' ? (
            <button type="button" class="btn btn-info btn-secondary btn-fill" autoComplete="off" onClick={this.enableUser.bind(this, row)}>
                Enable
            </button>
            ) : (
            <button type="button" class="btn btn-info btn-danger btn-fill" autoComplete="off" onClick={this.disableUser.bind(this, row)}>
                Disable
            </button>
            )}
        </div>
        )
    }

    formatName(cell, row) {
        return row.firstname + ' ' + row.lastname;
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    logAsUser(account) {
        adminUserAccounts.loginAsUser(account.user_id, function(response) {
            modal.showInfo("Logging you into user.", "success", "top", "center");
            user.getUserData();
            window.location.href = '/';
        });
    }

    disableUser(account) {
        var self = this;
        adminUserAccounts.disableUser(account.user_id, function(response) {
            modal.showInfo("User account disabled.", "success", "top", "center");
            adminContractors.getContractors(function(response){
                self.setState({
                    contractorData: response.data
                })
            })
        });
    }

    enableUser(account) {
        var self = this;
        adminUserAccounts.enableUser(account.user_id, function(response) {
            modal.showInfo("User account enabled.", "success", "top", "center");
            adminContractors.getContractors(function(response){
                self.setState({
                    contractorData: response.data
                })
            })
        });
    }

    render(){
        var self = this;
        var contractorData = this.state.contractorData;

        if (contractorData !== null) {
            contractorData = this.state.contractorData.map(function(account) {
                return self.flattenObject(account);
            });
        }

        return (
            <div class="content">
                {contractorData != null ? (
                    <BootstrapTable data={contractorData} version='4' striped search pagination>
                        <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='firstname' dataFormat={this.formatName} dataSort={ true }>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='phone' dataSort={ true }>Phone</TableHeaderColumn>
                        <TableHeaderColumn dataField='email' dataSort={ true }>Email</TableHeaderColumn>
                        <TableHeaderColumn dataField='company' dataSort={ true }>Company</TableHeaderColumn>
                        {/* <TableHeaderColumn dataField='' dataSort={ true }>Manager</TableHeaderColumn> TODO: Add param for managers */}
                        <TableHeaderColumn dataAlign='center' dataFormat={this.formatActionOptions.bind(this)}>Action</TableHeaderColumn>
                    </BootstrapTable>
                ) : (
                    <p>No contractors found.</p>
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Contractors/ContractorTable.jsx